//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/DebugSession.js";
let d=[[],[[[],"JtCompare",{},0,0],[["inputPart","structure_options","config_file"],"JtCompareUgtopv",{},3,0],[["exeName","inputPart","config_file"],"JtCompareInteropTranslators",{},3,0],[["exeName","inputPart","structure_option","config_file","compareFlag","pre_options"],"RunInteropTranslatorsOnlyWithPreOptions",{},6,0],[["exeName","inputPart","structure_options","config_file","compareFlag"],"RunInteropTranslatorsOnly",{},5,0],[["exeName","inputPart","structure_options","config_file","config_file1","extension_type"],"RunBidirectionalInteropTranslators",{},6,0],[[],"RunInteropTranslatorsJtCompareOnly",{},0,0],[["logFileName","exeName","relativeTolerance"],"RunInteropTranslatorsLogCompareOnly",{},3,0],[[],"JtSaveManaged",{},0,0],[["dataset_name","managed_jt_name"],"DownloadJtFileFromTeamcenter",{},2,0],[["sManagedmodeFilepath"],"DownloadFileFromTeamcenter",{R_:{outputFile:''}},1,0],[["datasetInfo"],"DownloadNamedRefs",{R_:{sFilePath:''}},1,0],[["sArchivePath"],"ExtractZip",{},1,0],[["inputPart","structure_options","config_file"],"RunUgtopvOnly",{},3,0]],[]];
SPLM.NXTranslatorsAutotestPrint = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.NXTranslatorsAutotestPrint";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.NXTranslatorsAutotestPrint.DatasetInfo = class{
    constructor(item,revision,relation,datasetType,namedRefType,datasetName){
        this.item=item;this.revision=revision;this.relation=relation;this.datasetType=datasetType;this.namedRefType=namedRefType;this.datasetName=datasetName;}
    get Item(){return this.item}
    set Item(val){this.item = val}
    get Revision(){return this.revision}
    set Revision(val){this.revision = val}
    get Relation(){return this.relation}
    set Relation(val){this.relation = val}
    get Datasettype(){return this.datasetType}
    set Datasettype(val){this.datasetType = val}
    get Namedreftype(){return this.namedRefType}
    set Namedreftype(val){this.namedRefType = val}
    get Datasetname(){return this.datasetName}
    set Datasetname(val){this.datasetName = val}
};

export default SPLM;